// extracted by mini-css-extract-plugin
export default {"blogPostContainer":"BlogPost_blogPostContainer__314K7","date":"BlogPost_date__WDX5m"};